module.exports = __webpack_public_path__ + "static/media/twitterColor.e950b9bc.svg";